import "./UserContentRights.less";

import { Spin } from "antd";
import * as React from "react";
import { RouteComponentProps } from "react-router-dom";

import { SectionApi } from "lib/api";
import { CancellationToken } from "lib/api/base";
import { IBaseProps } from "lib/data/interfaces";
import { StateService } from "lib/services";

import { Section } from "lib/data/model";
import { SectionNode } from "./components/SectionNode/SectionNode";

interface IUserContentRightsProps extends IBaseProps, RouteComponentProps<any> {

}

interface IUserContentRightsState {
	isLoading: boolean;
}

export class UserContentRights extends React.Component<IUserContentRightsProps, IUserContentRightsState> {

	public static readonly BasePath: string = "/admin/usercontentrights";


	private apiCancellationToken: CancellationToken = new CancellationToken();

	private section!: Section;

	public constructor(props: IUserContentRightsProps) {

		super(props);

		this.state = {
			isLoading: true
		};
	}

	public async componentWillMount() {

		const section = await SectionApi.getSection(undefined, undefined);

		if (section !== undefined) {

			this.section = section;

			StateService.setCancelableState(() => this.setState({ isLoading: false }), this.apiCancellationToken);
		}
	}

	public componentWillUnmount() {

		// Cancel Outstanding API Calls
		this.apiCancellationToken.cancel();
	}

	public render() {

		if (this.state.isLoading) {

			return (<Spin />);
		}
		else {

			return (
				<div className="user-content-rights">

					<SectionNode
						section={this.section}
						canExpand={false}
					/>
				</div>
			);
		}
	}
}
